import {localeServerSideProps} from "@i18n/pages";
import Booking from "@page-containers/booking/booking";
import {I18nNamespace} from "@i18n";

Booking.optOutOfPracticeData = true;

export const getServerSideProps = localeServerSideProps([
  I18nNamespace.WEB_SCHEDULING,
  I18nNamespace.DB,
]);

export default Booking;
